import React, { useState, useEffect } from "react";
import {
  List,
  Datagrid,
  TextField,
  ShowButton,
  SimpleShowLayout,
  Show,
  Edit,
  SimpleForm,
  TextInput,
  DateInput,
  FilterList,
  FilterListItem,
  Pagination,
  useNotify,
  useUnselectAll,
  useRefresh,
  useDataProvider,
  useListContext,
  FilterLiveSearch,
  //ReferenceManyField,
  useGetList,
  useShowController,
} from "react-admin";
import {
  Card,
  CardContent,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField as MuiTextField,
  Button as MuiButton,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Typography,
} from "@material-ui/core";
import Header from "../utils/auth/getHeader";
import { API } from "aws-amplify";
import { AssignFlag } from "./AssignFlag";
import { AssignTag } from "./AssignTag";
import FollowerOrUsernameField from "./TikTokData";


const BulkActionSendSms = () => {
  const [open, setOpen] = useState(false);
  const [smsText, setSmsText] = useState(""); // This should be set to your SMS.invitation field value
  const { selectedIds, onUnselectItems } = useListContext();
  const notify = useNotify();
  const refresh = useRefresh();

  // Function to open the modal dialog
  const handleOpen = () => {
    // Here you would fetch and set the default message from your `SMS.invitation` field
    // setSmsText('Your default SMS invitation text');
    setOpen(true);
  };

  // Function to close the modal dialog
  const handleClose = () => {
    setOpen(false);
  };

  // Function to send SMS
  const handleSend = async () => {
    try {
      const header = await Header.getHeader();
      await API.post("secure-api", "api/admin/sendsms", {
        headers: {
          ...header,
          "Access-Control-Allow-Headers": "*",
          "Access-Control-Allow-Origin": "*",
        },
        body: {
          sms_text: smsText,
          user_ids: selectedIds,
          resource_id: 'profile',
        },
      });
      notify("SMS sent successfully", "info");
      handleClose();
      onUnselectItems();
      refresh();
    } catch (error) {
      notify("Error: SMS not sent", "warning");
    }
  };

  return (
    <>
      <Button label="Send SMS" onClick={handleOpen}>Send SMS</Button>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">Send SMS</DialogTitle>
        <DialogContent>
          <MuiTextField
            autoFocus
            margin="dense"
            id="smsText"
            label="SMS Message"
            type="text"
            fullWidth
            multiline
            rows={4}
            value={smsText}
            onChange={(event) => setSmsText(event.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <MuiButton onClick={handleClose} color="primary">
            Cancel
          </MuiButton>
          <MuiButton onClick={handleSend} color="primary">
            Send
          </MuiButton>
        </DialogActions>
      </Dialog>
    </>
  );
};


const AssignCampaignModal = ({ open, handleClose }) => {
  const [campaign, setCampaign] = useState("");
  const [campaigns, setCampaigns] = useState([]);
  const [loading, setLoading] = useState(false);
  const dataProvider = useDataProvider();
  const notify = useNotify();
  const unselectAll = useUnselectAll("users");
  const refresh = useRefresh();
  const { selectedIds } = useListContext();
  console.log(selectedIds);
  useEffect(() => {
    setLoading(true);
    dataProvider
      .getList("campaign", {
        pagination: { page: 1, perPage: 100 },
        sort: { field: "resource_name" },
        filter: {},
      })
      .then(({ data }) => {
        setCampaigns(data);
      })
      .catch((error) => {
        notify("Error loading campaigns: " + error.message, "warning");
      })
      .finally(() => {
        setLoading(false);
      });
  }, [dataProvider, notify]); // Dependencies for useEffect.

  const handleAssign = async () => {
    try {
      const header = await Header.getHeader();
      await API.post("secure-api", "api/admin/campaignassign", {
        headers: {
          ...header,
          "Access-Control-Allow-Headers": "*",
          "Access-Control-Allow-Origin": "*",
        },
        body: {
          user_ids: selectedIds,
          campaign_id: campaign.id, // Adding the campaign_id to the payload
        },
      });
      notify("Users updated successfully", "info");
      refresh();
      unselectAll();
    } catch (error) {
      // Handle error case
      notify("Error: Users not updated", "warning");
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="form-dialog-title"
    >
      <DialogTitle id="form-dialog-title">Invite to Campaign</DialogTitle>
      <DialogContent>
        {loading ? (
          <p>Loading campaigns...</p>
        ) : (
          <FormControl fullWidth>
            <InputLabel id="campaign-select-label">Campaign</InputLabel>
            <Select
              labelId="campaign-select-label"
              id="campaign-select"
              value={campaign.id} // Modified to use campaign.id
              onChange={(e) => {
                // Find the selected campaign object and set it
                const selectedCampaign = campaigns.find(
                  (c) => c.id === e.target.value
                );
                setCampaign(selectedCampaign);
              }}
            >
              {campaigns.map((campaignItem) => (
                <MenuItem key={campaignItem.id} value={campaignItem.id}>
                  {campaignItem.resource_name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          Cancel
        </Button>
        <Button onClick={handleAssign} color="primary" disabled={loading}>
          Assign
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const CustomBulkActions = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [flagModalOpen, setFlagModalOpen] = useState(false);
  const [tagModalOpen, setTagModalOpen] = useState(false);

  return (
    <>
      <Button onClick={() => setModalOpen(true)}>Add To Campaign</Button>
      <AssignCampaignModal
        open={modalOpen}
        handleClose={() => setModalOpen(false)}
      />
      <Button onClick={() => setFlagModalOpen(true)}>Flag User</Button>
      <AssignFlag
        open={flagModalOpen}
        handleClose={() => setFlagModalOpen(false)}
      />
      <Button onClick={() => setTagModalOpen(true)}>Tag User</Button>
      <AssignTag
        open={tagModalOpen}
        handleClose={() => setTagModalOpen(false)}
      />
    </>
  );
};


const Aside = () => {
  const { data: tags, isLoading } = useGetList('tag', {
    pagination: { page: 1, perPage: 100 },
    sort: { field: 'resource_name', order: 'ASC' },
    filter: {},
  });

  return (
    <div style={{ width: 200, margin: '1em' }}>

      <FilterLiveSearch source="q" label="Search" />
      <FilterList label="Gender">
        <FilterListItem label="Female" value={{ gender: 'Female' }} />
        <FilterListItem label="Male" value={{ gender: 'Male' }} />
        <FilterListItem label="Other" value={{ gender: 'Other' }} />
        <FilterListItem label="Decline" value={{ gender: 'Decline' }} />
      </FilterList>

      <FilterList label="Min Age">
        <FilterListItem
          label="25"
          value={{
            min_age: (new Date().getFullYear() - 25).toString() + '-00-00',
          }}
        />
        <FilterListItem
          label="30"
          value={{
            min_age: (new Date().getFullYear() - 30).toString() + '-00-00',
          }}
        />
        <FilterListItem
          label="35"
          value={{
            min_age: (new Date().getFullYear() - 35).toString() + '-00-00',
          }}
        />
        <FilterListItem
          label="40"
          value={{
            min_age: (new Date().getFullYear() - 40).toString() + '-00-00',
          }}
        />
        <FilterListItem
          label="45"
          value={{
            min_age: (new Date().getFullYear() - 45).toString() + '-00-00',
          }}
        />
        <FilterListItem
          label="50"
          value={{
            min_age: (new Date().getFullYear() - 50).toString() + '-00-00',
          }}
        />
      </FilterList>

      <FilterList label="Max Age">
        <FilterListItem
          label="30"
          value={{
            max_age: (new Date().getFullYear() - 30).toString() + '-00-00',
          }}
        />
        <FilterListItem
          label="35"
          value={{
            max_age: (new Date().getFullYear() - 35).toString() + '-00-00',
          }}
        />
        <FilterListItem
          label="40"
          value={{
            max_age: (new Date().getFullYear() - 40).toString() + '-00-00',
          }}
        />
        <FilterListItem
          label="45"
          value={{
            max_age: (new Date().getFullYear() - 45).toString() + '-00-00',
          }}
        />
        <FilterListItem
          label="50"
          value={{
            max_age: (new Date().getFullYear() - 50).toString() + '-00-00',
          }}
        />
      </FilterList>

      <FilterList label="Min TikTok Followers">
        <FilterListItem label="100" value={{ min_follower_count: 100 }} />
        <FilterListItem label="500" value={{ min_follower_count: 500 }} />
        <FilterListItem label="1000" value={{ min_follower_count: 1000 }} />
      </FilterList>

      <FilterList label="Country">
        <FilterListItem label="Canada" value={{ country: 'CA' }} />
        <FilterListItem label="US" value={{ country: 'US' }} />
      </FilterList>
      <FilterList label="Year Joined">
        <FilterListItem label="2025" value={{ year_joined: '2025' }} />
        <FilterListItem label="2024" value={{ year_joined: '2024' }} />
        <FilterListItem label="2023" value={{ year_joined: '2023' }} />
        <FilterListItem label="2022" value={{ year_joined: '2022' }} />
      </FilterList>
      <FilterList label="Month Joined">
        <FilterListItem label="January" value={{ month_joined: '01' }} />
        <FilterListItem label="February" value={{ month_joined: '02' }} />
        <FilterListItem label="March" value={{ month_joined: '03' }} />
        <FilterListItem label="April" value={{ month_joined: '04' }} />
        <FilterListItem label="May" value={{ month_joined: '05' }} />
        <FilterListItem label="June" value={{ month_joined: '06' }} />
        <FilterListItem label="July" value={{ month_joined: '07' }} />
        <FilterListItem label="August" value={{ month_joined: '08' }} />
        <FilterListItem label="September" value={{ month_joined: '09' }} />
        <FilterListItem label="October" value={{ month_joined: '10' }} />
        <FilterListItem label="November" value={{ month_joined: '11' }} />
        <FilterListItem label="December" value={{ month_joined: '12' }} />
      </FilterList>
      <FilterList label="Show Flagged">
        <FilterListItem label="Yes" value={{ flagged: true }} />
      </FilterList>
      <FilterList label="Tags">
        {!isLoading && tags ? (
          tags.map((tag) => (
            <FilterListItem
              key={tag.id}
              label={tag.resource_name || 'Unnamed Flag'}
              value={{
                tag: tag.id + '+' + tag.resource_name || 'unnamed_flag',
              }}
            />
          ))
        ) : (
          <div>Loading...</div>
        )}
      </FilterList>
    </div>
  );
};


const UserGrid = (props) => (
  <Datagrid {...props}>
    <TextField source="first_name" label="First Name" />
    <TextField source="last_name" label="Last Name" />
    <TextField source="credit" label="Points" />
    <TextField source="last_sms_time" label="Last SMS Time" />
    <TextField source="gender" label="Gender" />
    <TextField source="cognito_email" label="Email" />
    <TextField source="date_created" label="Date Joined" />
    <TextField
      source="social_tiktok.tiktok_user_info.data.user.follower_count"
      label="Follower#"
    />
    <FollowerOrUsernameField label="Follower#" />
    <TextField source="cognito_birthdate" label="Birthdate" />
    <TextField label="no_share" source="no_partner_sharing" />
    <TextField label="tags" source="tags" />
    <TextField source="country" label="Country" />
    <ShowButton basePath="/user" />
  </Datagrid>
);

const UserPagination = () => <Pagination rowsPerPageOptions={[50, 100, 200, 500]} />;

export const UserList = (props) => {
  const unselectAll = useUnselectAll('user');

  useEffect(() => {
    unselectAll();
  }, [unselectAll]);
  return (
    <List {...props} actions={null} pagination={<UserPagination />}>
      <Card>
        <CardContent style={{ display: "flex", paddingTop: "50px" }}>
          <Aside />
          <UserGrid
            {...props}
            bulkActionButtons={
              <>
                <CustomBulkActions />
                <BulkActionSendSms />
              </>
            }
          />
        </CardContent>
      </Card>
    </List>
  );
};

export const UserEdit = (props) => {
  return (
    <Edit title="Edit User" {...props}>
      <SimpleForm>
        <TextInput source="first_name" label="First Name" />
        <TextInput source="last_name" label="Last Name" />
        <TextInput source="gender" label="Gender" />
        <TextInput source="country" label="Country Code" />
        <TextInput source="zip_code" label="Zip Code" />
        <TextInput source="profile_picture" label="Profile Picture" />
        <DateInput source="birthday" label="Birthday" />
      </SimpleForm>
    </Edit>
  );
};





export const UserShow = (props) => {
  const { record } = useShowController(props);
  const dataProvider = useDataProvider();
  const [campaigns, setCampaigns] = useState([]);
  const [campaignDetails, setCampaignDetails] = useState([]);
  // Fetch all tags and flags for mapping
  const { data: allTags } = useGetList('tag', {
    pagination: { page: 1, perPage: 100 },
    sort: { field: 'resource_name', order: 'ASC' },
    filter: {},
  });
  const { data: allFlags } = useGetList('flag', {
    pagination: { page: 1, perPage: 100 },
    sort: { field: 'resource_name', order: 'ASC' },
    filter: {},
  });

  // Helper to get tag or flag names from ids
  const getResourceNames = (ids, allItems) => {
    if (!Array.isArray(ids) || !Array.isArray(allItems)) return '';
    return ids
      .map((id) => {
        const idValue = typeof id === 'object' ? id.id : id;
        // Match only the base part before '+tag' or '+flag'
        const found = allItems.find((item) => {
          const baseId = String(idValue).split('+')[0];
          const itemBaseId = String(item.id).split('+')[0];
          return baseId === itemBaseId;
        });
        return found ? found.resource_name : idValue;
      })
      .filter(Boolean)
      .join(', ');
  };

  useEffect(() => {
    if (record?.pk) {
      const user_id = `${record.pk}+profile`;
      dataProvider
        .getList("usercampaigns", {
          filter: { user_id },
          sort: { field: "id", order: "DESC" },
          pagination: { page: 1, perPage: 25 },
        })
        .then(async ({ data }) => {
          setCampaigns(data);
          const fetches = data.map((c) => {
            const campaignId = c.sk + '+info';
            return dataProvider
              .getOne("campaign", { id: campaignId })
              .then((res) => ({ ...res.data, sk: c.sk }))
              .catch(() => null);
          });

          const results = await Promise.all(fetches);
          setCampaignDetails(results.filter(Boolean));
        });
    }
  }, [record, dataProvider]);

  if (!record) return null;


  // Wait for allTags and allFlags to load before rendering names
  const tagsLoaded = Array.isArray(allTags) && allTags.length > 0;
  const flagsLoaded = Array.isArray(allFlags) && allFlags.length > 0;

  return (
    <Show {...props}>
      <SimpleShowLayout>
        <TextField source="pk" label="User ID" />
        <TextField source="first_name" label="First Name" />
        <TextField source="last_name" label="Last Name" />
        {/* Show tags */}
        <Typography variant="body1" gutterBottom>
          <b>Tags:</b> {tagsLoaded ? getResourceNames(record.tags, allTags) : 'Loading...'}
        </Typography>
        {/* Show flags */}
        <Typography variant="body1" gutterBottom>
          <b>Flags:</b> {flagsLoaded ? getResourceNames(record.flags, allFlags) : 'Loading...'}
        </Typography>
        <div style={{ marginTop: 32 }}>
          <Typography variant="h6">Campaigns:</Typography>
          {campaigns.map((c) => {
            const campaign = campaignDetails.find((cd) => cd.sk === c.sk);
            return (
              <Card key={c.id} style={{ marginBottom: 16 }}>
                <CardContent>
                  <Typography variant="subtitle1">
                    {campaign ? campaign.resource_name : c.sk.replace("campaign-", "")}
                  </Typography>
                  <Typography color="textSecondary">
                    Status: {c.campaign_status}
                  </Typography>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </SimpleShowLayout>
    </Show>
  );
};